
    import { initSearchPage } from './src/components/search.js';
    import { initNavigation } from './src/components/navigation.js';

    document.addEventListener('DOMContentLoaded', async () => {
      await initNavigation();
      initSearchPage();
    });
  